import { render } from "./LeaveRequest.vue?vue&type=template&id=9fef836a&scoped=true"
import script from "./LeaveRequest.vue?vue&type=script&lang=js"
export * from "./LeaveRequest.vue?vue&type=script&lang=js"

import "./LeaveRequest.vue?vue&type=style&index=0&id=9fef836a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fef836a"]])

export default __exports__